import { getTrimmedLabel } from '@helpers/getTrimmedLabel'
import { addHttpsIfNeeded } from '@helpers/url'
import { CustomLink, Icon, Spreader } from '@ui-kit'

export const Website = ({ website }: { website: string }) => {
  if (website === '-') {
    return '-'
  }

  const { trimmedLabel } = getTrimmedLabel({
    label: website,
    maxNumberOfCharacters: 28
  })

  const href = addHttpsIfNeeded(website)

  return (
    <CustomLink href={href} target='_blank' onClick={e => e.stopPropagation()}>
      <Icon icon='icon-external-link-alt' />
      <Spreader spread={5} />
      {trimmedLabel}
    </CustomLink>
  )
}
